var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"loading":_vm.isLoading}},[(_vm.error)?_c('div',[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_c('WordpressDisplayContent',{attrs:{"pageData":this.pageData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }